import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Diensten',
  options: {
    [STORE_SERVICES.CATERING]: 'Catering',
    [STORE_SERVICES.TERRACE]: 'Terras beschikbaar',
    [STORE_SERVICES.DINE_IN]: 'Ter plaatse eten',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Online bestellen via FoodAmigos',
    [STORE_SERVICES.RESERVATION]: 'Reserveringen via FoodAmigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Reserveringen in restaurant',
  },
  labels: {
    reservation_total_seats: 'Totaal zitplaatsen',
    catering_min_people: 'Min. personen catering',
  },
};
